﻿$.fn.dxCtrlFileUploaderOnControl = function custom_dxCtrlFileUploaderOnControl(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfileuploaderoncontrol dx-ctrl");
        this.createInstance(new cdxCtrlFileUploaderOnControl(this, option));
    }
    return this;
}

window.cdxCtrlFileUploaderOnControl = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    this.mGetDxFileUploader = function () { return dx }

    var dx = null;
    function mConstruit() {
        container.empty();

        console.log("construit")
        container.parent().css({
            "position": "relative"
        })
        container.css({
            "position": "absolute",
            "width": "100%",
            "height": "100%",
            "z-index": "0"
        })
        var isInDrag = false
        container.parent().on("dragover", function (e) {
            //console.log("position: " + e.originalEvent.offsetX + "," + e.originalEvent.offsetY)
            if (e.originalEvent.offsetX > 30 && e.originalEvent.offsetX < container.innerWidth() - 30 &&
                e.originalEvent.offsetY > 30 && e.originalEvent.offsetY < container.innerHeight() - 30) {
                if (!isInDrag) {
                    if (typeof option.onBeforeStartDrag != 'undefined') option.onBeforeStartDrag()
                    dx.element().show()
                    dx.element().css("z-index", "10")
                    console.log("zindex10")
                    container.css("z-index", "10")
                    isInDrag = true
                }
            }
        });

        dx = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlFileUploaderMachine({
            bddCtrl: option.bddCtrl,
            accept: option.accept,
            multiple: option.multiple,
            pathTempUpload: option.pathTempUpload,
            onUploadStarted: function () {
                console.log("SHOW FILEUPLOADER")
                dx.element().show()
                dx.element().css("z-index", "10")
                console.log("zindex10")
                container.css("z-index", "10")
            },
            onValide: function (lstUrlFile) {
                dx.element().css("z-index", "")
                dx.element().hide()
                dx.element().css("display", "none")
                console.log("zindex0")
                container.css("z-index", "0")
                isInDrag = false
                if (typeof option.onValide != 'undefined') option.onValide(lstUrlFile);
            },
            onDragEnd: function (containerDrag) {
                if (!dx.isInUpload) {
                    dx.element().css("z-index", "")
                    dx.element().hide()
                    dx.element().css("display", "none")
                    console.log("HIDE FILEUPLOADER")
                    console.log("zindex0")
                    container.css("z-index", "0")
                    isInDrag = false
                }
            },
            onContentReady: function (e) {
                
                //debugger;
                window.setTimeout(function () {
                    dx.element().css("display","none")
                }, 0)
            }
        }).dxCtrlFileUploaderMachine("instance");
    }

    this.mGetContainerDragEnter = function () { return dx.$containerDragDrop }

    this.element = function () { return container }

    mConstruit();
}